import { Spreadsheet, getRangeAddress } from '@syncfusion/ej2-spreadsheet';
import { Uploader } from '@syncfusion/ej2-inputs';
import { ExcelWorksheetCellModel, ExcelWorksheetModel, SetWorkbookDataModel } from '../../Models/Excel/SetWorkbookDataModel';
import { ExcelDataService } from '../../DataService/ExcelDataService';

import { Grid, Filter, Page, Sort, RecordClickEventArgs, Edit, Toolbar, NewRowPosition } from '@syncfusion/ej2-grids';
import { Query, DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { closest, L10n } from '@syncfusion/ej2-base';
import { ModalHelper } from '../../Helpers/ModalHelper';
import { Toastr } from '../../Helpers/Toastr';
import { DropDownList, ChangeEventArgs } from '@syncfusion/ej2-dropdowns';
import { ConfirmModal } from '../../Helpers/ConfirmModal';
import { LookupDataService } from '../../DataService/LookupDataService';
import { CommonTablesDataService } from '../../DataService/CommonTablesDataService';
import { SyncfusionGridHelper } from '../../Helpers/SyncfusionGridHelper';

export class VesselCrossReferencesManager {

    constructor(private containerElement: JQuery) { }

    private erpGrid : Grid;
    private crossReferencesGrid : Grid;

    private addManualVesselModalHelper : ModalHelper;
    

    public initialize() {
        var self = this;

        Grid.Inject(Edit, Toolbar, Filter, Page, Sort);

        self.initializeUploadAndWorkbooksTable();
    }

    private initializeUploadAndWorkbooksTable() {
        var self = this;

        var loadingContainer = self.containerElement.find('#loading-container');
        var vesselCrossReferencesContainer = self.containerElement.find('#vessel-cross-references-container');

        
        self.addManualVesselModalHelper = new ModalHelper();
        self.addManualVesselModalHelper.createModal("add-manual-erp-vessel-popup", true);

        var manualAddVesselButton = self.containerElement.find('#add-vessel-button');
        manualAddVesselButton.off('click').on('click', () => {
            self.addManualVesselModalHelper.load(`?handler=ManualAddErpVessel`, undefined, () => {

            }, undefined);
        });

        (<any>window).initializManualAddErpVessel = () => {
            if(self.addManualVesselModalHelper.getModalContainer().find('.alert-danger').length != 0) {
                
            }
            else {
                Toastr.Success('Vessel added', 'The vessel was successfully added.')
                self.erpGrid.filterByColumn("Id", 'equal', `${crypto.randomUUID()}`, undefined, true)
            }
            
        }

        var erpContentWrapper : JQuery<HTMLElement> = self.containerElement.find('#erp-workbook-content-wrapper');
        var erpGridElement : JQuery<HTMLElement> = self.containerElement.find('#erp-vessel-grid');
        var erpContentElement : JQuery<HTMLElement> = erpGridElement;

        var uploadObject : Uploader;
        var uploadedDocumentId = '';

 
        var crossReferencesGridElement : JQuery<HTMLElement> = self.containerElement.find('#erp-vessel-cross-references-grid');
        var crossReferencesContentElement : JQuery<HTMLElement> = crossReferencesGridElement;

        var updateFromErpButton = self.containerElement.find('#update-from-erp-button');
        updateFromErpButton.off('click').on('click', () => {
            new ConfirmModal().initialize('Update vessels from ERP', 'Are you sure you want to update the vessels from the ERP?</br>This action cannot be reverted.', () => {
                CommonTablesDataService.updateVesselsFromErp((success) => {
                    location.reload();
                })
            }, () => {
            }, 'Confirm', 'Cancel')
        })

        var fileUploadInput = self.containerElement.find('#erp-vessel-file-upload-input');
    
        L10n.load({
            "vessel-en-US": {
                "uploader": { 
                    "dropFilesHint" : "Drop a file with vessel(s) here"
                }
            }
        })

        //TODO: Allow upload of erp vessel file
        uploadObject = new Uploader({
            maxFileSize: 40000000,
            autoUpload: false,
            asyncSettings: {
                saveUrl: '/api/company/commontables/erp/uploadvesselxlsx',
                removeUrl: '/api/company/commontables/removefile'
            },
            multiple: false,
            allowedExtensions: '.xlsx',
            locale: 'vessel-en-US',
            created: () => {
                loadingContainer.addClass('d-none');
                vesselCrossReferencesContainer.removeClass('d-none');
            },
            beforeUpload: () => {
                //spreadsheetElement.addClass('d-none');
                //spreadsheet.destroy();
            },
            selected: () => {
                erpContentWrapper.css('height', 'calc(85dvh - 98px)');
            },
            success: (args: any) => {                    
                if (args.operation == 'upload') {
                    uploadedDocumentId = args.e.target.response;
                    //spreadsheet.open({ file: args.file.rawFile });
                }
            },
        });

        let erpData: DataManager = new DataManager({
            url: '/api/company/lookup/erp/vessel',
            adaptor: new WebApiAdaptor
        });

        var erpColumns : any = [
                { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, allowFiltering: false, validationRules: { required: true }},
                { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, allowFiltering: false, width: '150px', validationRules: { required: true }},
            ];

        var manualVessels = (self.containerElement.data('manual-vessels') == 'True' || self.containerElement.data('manual-vessels') == 'true');
        if(!manualVessels) {
            erpColumns.push({ field: 'Key', headerText: 'Key', autoFit: true, allowFiltering: false, validationRules: { required: false }});
        } 

        erpColumns.push({ field: 'Name', headerText: 'Name', autoFit: true, validationRules: { required: false }});
        erpColumns.push({ field: 'Imo', headerText: 'IMO', autoFit: true, validationRules: { required: false }});

        if(manualVessels) {
            erpColumns.push({ field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, textAlign: 'Right', width: '75px', template: '${getManualVesselsExtraActions(data.Id)}' });
        } 

        self.erpGrid = new Grid(
        {
            height: '100%',
            dataSource: erpData,
            editSettings: { allowEditing: manualVessels, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
            columns: erpColumns,
            allowSorting: true,
            allowPaging: true,
            allowFiltering: true,
            allowSelection: false,
            enablePersistence: true,
            toolbarTemplate: '#erp-vessel-toolbar-template',
            pageSettings: { pageSize: 100 },
            // toolbar: ['Update', 'Cancel'],
            //actionComplete: actionComplete,
            created: () => {
                erpContentElement = erpContentElement.find('.e-content')

                loadingContainer.addClass('d-none');
                vesselCrossReferencesContainer.removeClass('d-none');

            },
            actionBegin: (args) => {
                if (!this.erpGrid) {
                    return;
                }

                if (SyncfusionGridHelper.isFilterAction(args)) {
                    this.erpGrid.pageSettings.currentPage = 1;
                }
            },
            dataBound: () => {
                    self.containerElement.find('button[data-action="remove-erp-vessel"]').each((index, element) => {
                        var deleteButton = $(element);
                        deleteButton.off('click').on('click', () => {
                            var vesselId = deleteButton.data('entity-id');
                            new ConfirmModal().initialize('Remove Vessel', 'Are you sure you want to remove this vessel?</br>This action cannot be reverted.', () => {
                                LookupDataService.removeErpVessel(vesselId, (result) => {
                                    if(result == true) {
                                        var index = self.erpGrid.getRowIndexByPrimaryKey(vesselId);
                                        var row = self.erpGrid.getRowByIndex(index);
                                        $(row).remove();
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })
                }
        });

        self.erpGrid.appendTo('#erp-vessel-grid');
        var vesselToolbar = this.containerElement.find('#erp-vessel-toolbar-template');
        if(vesselToolbar != undefined && vesselToolbar.length > 0) {
            var clearFiltersButton = vesselToolbar.find('#erp-vessel-clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.erpGrid.pageSettings.currentPage = 1;
                self.erpGrid.clearFiltering();
                self.erpGrid.refreshHeader();
            })
        }
        
        var fileInput = fileUploadInput.get(0);
        // render initialized Uploader
        uploadObject.appendTo(fileInput);

        fileUploadInput.removeClass('d-none');


        let data: DataManager = new DataManager({
            url: '/api/company/lookup/crossreferences/vessel',
            adaptor: new WebApiAdaptor
        });

        self.crossReferencesGrid = new Grid(
            {
                height: '100%',
                dataSource: data,
                editSettings: { allowEditing: true, allowAdding: false, allowDeleting: false, mode: 'Normal', newRowPosition: 'Top' },
                columns: [
                    { field: 'Id', isPrimaryKey: true, visible: false, allowEditing: false, validationRules: { required: true }},
                    { field: 'CreationDateTimeString', headerText: 'Creation date', autoFit: true, allowEditing: false, width: '150px', allowFiltering: false, validationRules: { required: true }},
                    { field: 'DataSource', headerText: 'Source', autoFit: true, width: '150px', allowSorting: false, allowFiltering: false, validationRules: { required: false }},
                    { field: 'VesselName', headerText: 'Vessel', autoFit: true, allowFiltering: true, validationRules: { required: false }},
                    { field: 'ErpVesselName', headerText: 'ERP Vessel', autoFit: true, allowFiltering: true, validationRules: { required: false }},
                    { field: 'ExtraActions', headerText: '', allowFiltering: false, allowEditing: false, autoFit: true, width: '75px', textAlign: 'Right', template: '${getVesselCrossReferencesExtraActions(data.Id)}' }
                ],
                allowSorting: true,
                allowPaging: true,
                allowFiltering: true,
                allowSelection: false,
                enablePersistence: true,
                toolbarTemplate: '#erp-vessel-cross-references-toolbar-template',
                pageSettings: { pageSize: 100 },
                // toolbar: ['Update', 'Cancel'],
                //actionComplete: actionComplete,
                created: () => {
                    crossReferencesContentElement = crossReferencesContentElement.find('.e-content')

                    loadingContainer.addClass('d-none');
                    vesselCrossReferencesContainer.removeClass('d-none');

                },
                actionBegin: (args) => {
                    if (!this.crossReferencesGrid) {
                        return;
                    }

                    if (SyncfusionGridHelper.isFilterAction(args)) {
                        this.crossReferencesGrid.pageSettings.currentPage = 1;
                    }
                },
                dataBound: () => {
                    self.containerElement.find('button[data-action="remove-vessel-xref"]').each((index, element) => {
                        var deleteButton = $(element);
                        deleteButton.off('click').on('click', () => {
                            var xrefId = deleteButton.data('entity-id');
                            new ConfirmModal().initialize('Remove Vessel Cross Reference', 'Are you sure you want to remove this cross reference?</br>This action cannot be reverted.', () => {
                                LookupDataService.removeVesselCrossReference(xrefId, (result) => {
                                    if(result == true) {
                                        var index = self.crossReferencesGrid.getRowIndexByPrimaryKey(xrefId);
                                        var row = self.crossReferencesGrid.getRowByIndex(index);
                                        $(row).remove();
                                    }
                                })
                            }, () => {
                            }, 'Confirm', 'Cancel')
                            
                        })
                    })
                }
            });

        self.crossReferencesGrid.appendTo('#erp-vessel-cross-references-grid');

        var crossReferencesToolbar = this.containerElement.find('#erp-vessel-cross-references-toolbar-template');
        if(crossReferencesToolbar != undefined && crossReferencesToolbar.length > 0) {
            var clearFiltersButton = crossReferencesToolbar.find('#erp-vessel-cross-references-clear-filters-button');
            clearFiltersButton.off('click').on('click', () => {
                self.crossReferencesGrid.pageSettings.currentPage = 1;
                self.crossReferencesGrid.clearFiltering();
                self.crossReferencesGrid.refreshHeader();
            })
        }

        // function actionComplete(args) {
        //     if ((args.requestType == 'save')) {
        //         args.promise.then((result) => {
        //             if(result.isSuccessStatusCode == false) {
        //                 Toastr.Error("Error when adding cross reference", args.reasonPhrase);
        //             }
        //         })
        //     }
        // }
    }
    

}